import React, {useEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';
import {Table} from "reactstrap";
import {Link} from "react-router-dom";
import {RacoonGroupEditRoute} from "../../routesConstants";
import Tooltip from "../../../helpers/ToolTip";
import moment from "moment/moment";
import numberFormat from "../../../helpers/numberFormat";
import {GROUP_RACOON_TYPE} from "./GroupForm";

const GroupTable = ({array, onChangeType}) => {
  return (
    <Table borderless>
      <thead>
      <tr>
        <th className={'kt-padding-l-20'}>Название</th>
        <th>Тип</th>
        <th>Начало</th>
        <th>Конец</th>
        <th className={'text-center'}>Примерная сумма</th>
        <th className={'text-center'}>Контрагентов</th>
        <th className={'text-center'}>Разница</th>
        <th className={'text-center'}>В реестре</th>
        <th className={'text-center'}>Синк</th>
        <th className={'text-center'}>Актуальный</th>
      </tr>
      </thead>
      <tbody>
      {array.map((item, i)=>{
        return <React.Fragment key={i}>
          {renderRow(item, onChangeType)}
        </React.Fragment>
      })}
      </tbody>

    </Table>
  );
};

export default GroupTable;

const countLegend = {
  duplicates:"Дубли в Реестре",
  onlyInKayar:"Нет в реестре",
  onlyInGoogle:"Нет в Каяре",
  unrecognized:"Нераспознанные",
}

const renderBuble = (count, name)=>{
  if(typeof count === "number"){
    return <Tooltip content={name}>
      <div className={`bg-secondary number-circle ${String(count).length > 2 ? 'small' : ''}`}>{count}</div>
    </Tooltip>
  }

}

const renderTdWithBuble = (item) => {
  return <td>
    <div className={'d-flex gap-2 justify-content-center'}>
      {renderBuble(item.onlyInKayar,countLegend.onlyInKayar)}
      {renderBuble(item.onlyInGoogle,countLegend.onlyInGoogle)}
      {renderBuble(item.unrecognized,countLegend.unrecognized)}
      {renderBuble(item.duplicates,countLegend.duplicates)}
    </div>
  </td>
}
const typeColor = (type) => {
  if (type === "Рабочий") return "green"
  if (type === "Черновик") return "black"
  return "yellow"
}

const TypeMenu = ({item, onChangeType}) => {
  const anchorRef = useRef(null)
  const menuRef = useRef(null)
  const [open, setOpen] = useState(false)
  const [pos, setPos] = useState({top: 0, left: 0})

  const place = () => {
    const rect = anchorRef.current.getBoundingClientRect()
    setPos({top: rect.top, left: rect.right + 6})
  }

  useEffect(() => {
    if (!open) return
    const close = (e) => {
      if (anchorRef.current?.contains(e.target) || menuRef.current?.contains(e.target)) return
      setOpen(false)
    }
    const move = () => place()
    document.addEventListener('mousedown', close)
    window.addEventListener('scroll', move, true)
    window.addEventListener('resize', move)
    return () => {
      document.removeEventListener('mousedown', close)
      window.removeEventListener('scroll', move, true)
      window.removeEventListener('resize', move)
    }
  }, [open])

  return <>
    <span
      ref={anchorRef}
      role="button"
      style={{cursor: 'pointer'}}
      onClick={() => {
        if (open) {
          setOpen(false)
          return
        }
        place()
        setOpen(true)
      }}
    >
      <Tooltip content={item.typeRacoon} direction="top">
        <i className="fa fa-circle" style={{color: typeColor(item.typeRacoon)}}/>
      </Tooltip>
    </span>
    {open && createPortal(
      <div
        ref={menuRef}
        className="dropdown-menu show"
        style={{position: 'fixed', top: pos.top, left: pos.left, display: 'block', zIndex: 2000}}
      >
        {GROUP_RACOON_TYPE.map(type => (
          <button
            type="button"
            key={type}
            className={`dropdown-item${type === item.typeRacoon ? ' active' : ''}`}
            onClick={() => {
              setOpen(false)
              if (type !== item.typeRacoon) onChangeType(item.id, type)
            }}
          >
            <i className="fa fa-circle mr-2" style={{color: typeColor(type)}}/>
            {type}
          </button>
        ))}
      </div>,
      document.body
    )}
  </>
}

const renderRow = (item, onChangeType) => {
  return <tr>
    <td className={'kt-padding-l-20'}>
      <Link to={RacoonGroupEditRoute + item.id}>
        {item.name}
      </Link>
    </td>
    <td>
      {!item.archive && <TypeMenu item={item} onChangeType={onChangeType}/>}
    </td>
    <td>{moment(item.startDate).format('DD.MM.YYYY')}</td>
    <td>{moment(item.endDate).format('DD.MM.YYYY')}</td>
    <td className={'text-center'}><Link to={{
      pathname: RacoonGroupEditRoute + item.id,
      hash: 'racoon',
      search: `?start=${moment(item.startDate).format('DD.MM.YYYY')}&end=${moment(item.endDate).format('DD.MM.YYYY')}&id=${item.id}`
    }}
                                        target={'_blank'}>
      {numberFormat(item.approximateSumm)}
    </Link></td>
    <td className={'text-center'}>{item.counterpartiesCount}</td>
    <td className={'text-center'}>{item.differences && <i className="fa fa-cog text-danger"/>}</td>
    {renderTdWithBuble(item)}
    <td className={'text-center'}>{item.lastUpdateSumm}</td>
    <td className={'text-center'}>{item.archive ? <i className={"fa fa-times-circle text-danger"}/> :
      <i className={"fa fa-check-circle text-success"}/>
    }</td>
  </tr>
}
